import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import AuthLayout from "../../shared/containers/AuthLayout";
import {IMAGE_PERMISSION_RWE} from "../../shared/constants/image";
import {
  addImageConnect,
  deleteImage,
  getImage,
  getRights,
  removeImageConnect
} from "./actions/imageAction";
import {IMAGE_INACTIVE} from "./constants/actionTypes";
import Seniors from "./components/seniors";
import {ROUTER_ROOT} from "../../shared/constants/routers";
import {ANALYTICS_SPECS} from "../../shared/constants";
import {sendAnalyticsEvent} from "../../shared/actions/analytics";


class Image extends React.Component {

  static propTypes = {
    image: PropTypes.shape({
      hash: PropTypes.string,
      url: PropTypes.string,
      title: PropTypes.string,
      rights: PropTypes.number,
      seniors: PropTypes.array,
      comments: PropTypes.array
    })
  };

  static defaultProps = {
    image: {}
  };

  state = {
    errors: {},
    onDeleting: false
  };

  componentDidMount() {
    this.props.dispatch(getImage(decodeURIComponent(this.props.match.params.imageHash)));
    if (!this.props.image.rights) {
      this.props.dispatch(getRights(decodeURIComponent(this.props.match.params.imageHash)));
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: IMAGE_INACTIVE });
  }

  deleteImage() {
    this.props.dispatch(deleteImage(this.props.image.hash))
      .then(() => {
        this.props.history.push(ROUTER_ROOT);
      });

      sendAnalyticsEvent(ANALYTICS_SPECS.DIARY.NAME, ANALYTICS_SPECS.DIARY.EVENTS.CONFIRM_IMAGE_DELETE);
  }

  shouldDelete = () => {
    this.setState({"onDeleting": true});

    sendAnalyticsEvent(ANALYTICS_SPECS.DIARY.NAME, ANALYTICS_SPECS.DIARY.EVENTS.DELETE_IMAGE);
  }

  cancelDeleting = () => {
    this.setState({"onDeleting": false});

    sendAnalyticsEvent(ANALYTICS_SPECS.DIARY.NAME, ANALYTICS_SPECS.DIARY.EVENTS.CANCEL_IMAGE_DELETE);
  }

  onCheckboxChange = (state, device, profile) => {
    state
      ? this.props.dispatch(addImageConnect(this.props.image.hash, profile))
      : this.props.dispatch(removeImageConnect(this.props.image.hash, profile));
  };

  render() {
    const {title, url} = this.props.image;

    return (
      <AuthLayout
        title={title}
        onBackLink={this.props.history.goBack}
        headerClass="shortHeader">
        <div id="imageView">
          {this.props.image.rights === IMAGE_PERMISSION_RWE && (
            this.state.onDeleting ? (
              <div
                className="flexBox direction-column flex confirmDeletionContainer">
                <div>
                  {__("Should the picture really be deleted?")}
                </div>
                <button className="buttonPrimary" onClick={() => this.deleteImage()}>
                  {__("Yes")}
                </button>
                <button className="buttonPrimary" onClick={this.cancelDeleting}>
                    {__("Abort")}
                </button>
              </div>
            ) : (
              <button className="buttonPrimary" onClick={this.shouldDelete}>
                {__("Remove image")}
              </button>
            )
          )}
          <div
            className="fullscreenImage"
            style={{
              backgroundImage: `url(${url})`
            }}
          />
          {this.props.image.seniors.length > 1 &&
            <Seniors onCheckbox={this.onCheckboxChange}
                     seniors={this.props.image.seniors.map((senior) => {
                       return {
                         ...senior,
                         checkbox: this.props.image.seniors.find((id) => id === senior.prof_id) ? true : false
                       }
                     })} />
          }
        </div>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    image: state.image
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { deleteImage: deleteImage },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Image));
